// removed by extract-text-webpack-plugin
module.exports = {"title":"izIrXPzdup28xMhv1643z","box_input_address":"_2D1kBT-a2j1wyXqQlBWlnz","step_process":"Bez0--ixY7WunW-2JLQ72"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/choose_address.css
// module id = 3044
// module chunks = 0